export default __webpack_public_path__ + "static/media/checkbox-bird.cba06277.svg";